import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

import { LogoLoginMobile } from '@/assets/img/LogoLoginMobile'
import { ModalConfirmComponent } from '@/modules/shared/components/modal-confirm.component'
import { useMainStore } from '@/modules/shared/stores/main.store'
import { version } from '../../../../package.json'

interface AuthLayoutProps {
	children: ReactNode
	titleAuth: string
	navigation?: string
	route?: string
	showNavigation?: boolean
	showVersion?: boolean
}

export function AuthLayoutComponent({
	children,
	titleAuth,
	navigation,
	route,
	showNavigation = true,
	showVersion = true,
}: AuthLayoutProps) {
	const { confirmation } = useMainStore()

	return (
		<div className="min-h-screen bg-slate-50 dark:bg-gray-900 flex flex-col">
			<header className="relative">
				<div className="bg-red-700 h-32  relative overflow-hidden">
					<div className="absolute inset-0 z-0 bg-black/10" />
					<div className="absolute -top-24 z-0 -right-24 w-48 h-48 bg-white/10 rounded-full" />
					<div className="absolute -bottom-12 z-0 -left-12 w-32 h-32 bg-white/5 rounded-full" />
				</div>
				<div className="absolute -bottom-20 z-50 left-1/2 transform -translate-x-1/2 bg-white dark:bg-gray-800 rounded-full  shadow-sm">
					<LogoLoginMobile />
				</div>
			</header>

			<main className="flex-1 flex flex-col  px-4 py-8">
				<div className="w-full max-w-md mx-auto space-y-8">
					<div className="text-center space-y-2 mt-20">
						<h1 className="text-xl md:text-2xl  md:pt-6 font-bold text-gray-900 dark:text-white">
							{titleAuth}
						</h1>
					</div>

					<div className=" dark:bg-gray-800 rounded-2xl shadow-none border-none border-gray-200 dark:border-gray-700">
						{children}
					</div>

					{showNavigation && navigation && route && (
						<div className="text-center">
							<Link
								to={route}
								className="inline-flex items-center gap-2 text-sm font-medium text-gray-600 dark:text-gray-400 hover:text-red-600 dark:hover:text-red-400 transition-colors duration-200 group"
							>
								{navigation}
							</Link>
						</div>
					)}
				</div>
			</main>

			{showVersion && (
				<footer className="py-6 text-center">
					<p className="text-xs text-gray-500 dark:text-gray-400">
						Versão {version}
					</p>
				</footer>
			)}

			<ModalConfirmComponent
				message={confirmation.message}
				onClose={confirmation.onClose}
				onConfirm={confirmation.onConfirm}
				title={confirmation.title}
				isOpen={confirmation.isOpen}
			/>
		</div>
	)
}
